import React, { useEffect } from "react";
import {
  Form,
  Input,
  DatePicker,
  TimePicker,
  Select,
  Mentions,
  Button,
  message,
  Checkbox
 } from 'antd';
import timeZones from '../../utils/live-schedules/drop-down-tables/timeZones';
import dayTypes from '../../utils/live-schedules/drop-down-tables/dayTypes';

const { TextArea } = Input;
const { Option } = Select;


const datePickerFormat = 'h:mm a, MMM Do'
const durationFormat = 'HH:mm';

const FormItem = Form.Item;

const AddTourGeneralForm = ({ resource, itemDetails, user, confirmDialogue, ...props }) => {
  const { itemType } = itemDetails;
  const { getFieldDecorator, getFieldsError, getFieldsValue } = props.form;

  const invalidForm = () => {
    message.config({
      top: 150,
      duration: 5,
      maxCount: 5,
    });
    message.error('You have one or more invalid form inputs!');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = {};
    // collect all fields currently in error state
    for ( const [field, error] of Object.entries(getFieldsError()) ) {
      if (error) {
        errors[`${field}`] = error;
      }
    }
    if (Object.values(errors).length === 0) {
      console.log('Success! Received values of form: ', getFieldsValue())
      props.createTour();
    } else {
      invalidForm();
      console.log('Invalid Form! ', errors);
    }
  };

  const validateTourStartTime = (rule, value, callback) => {
    const form = props.form;
    const tourEndTime = form.getFieldValue('tourEndTime');
    // *** Note: Not necessary since we're adjusting tourEndTime whenever a change in tourStartTime field
    // if (tourEndTime.isBefore(value)) {
    //   callback('Tour start time cannot occur after tour end time!');
    // } else {
    //   callback();
    // }
  }

  const validateTourEndTime = (rule, value, callback) => {
    const form = props.form;
    const tourStartTime = form.getFieldValue('tourStartTime');
    if (tourStartTime.isAfter(value)) {
      callback('Tour end time cannot occur before tour start time!');
    } else {
      callback();
    }
  }

  const validateMealStartTime = (rule, value, callback) => {
    const form = props.form;
    const tourStartTime = form.getFieldValue('tourStartTime').clone(); // clone() to prevent side effects
    const tourEndTime = form.getFieldValue('tourEndTime');
    const mealEndTime = form.getFieldValue('mealEndTime');
    if (value.isBefore(tourStartTime)) {
      callback('Meal cannot begin before tour start time!');
    } else if (value.isAfter(tourEndTime)) {
      callback('Meal cannot begin after tour end time!')
    } else if (value.isAfter(mealEndTime)) {
      callback('Meal cannot begin after meal end time!')
    } else {
      callback();
    }
  }

  const validateMealEndTime = (rule, value, callback) => {
    const form = props.form;
    const tourStartTime = form.getFieldValue('tourStartTime');
    const tourEndTime = form.getFieldValue('tourEndTime');
    const mealStartTime = form.getFieldValue('mealStartTime');
    if (value.isBefore(tourStartTime)) {
      callback('Meal cannot end before tour start time!')
    } else if (value.isAfter(tourEndTime)) {
      callback('Meal cannot end after tour end time!')
    } else if (value.isBefore(mealStartTime)) {
      callback('Meal cannot end before meal start time!');
    } else {
      callback();
    }
  }

  const validateCommentField = (rule, value, callback) => {
    const form = props.form;
    if (value.length > 30) {
      callback('Maximum length is 30 characters!')
    } else {
      callback();
    }
  }

    /**
     * populate fields on initial component mount
     * (getFieldDecorator overrides `value` on forms)
     */
    useEffect(() => {
      const form = props.form;
      form.setFieldsValue({
        tourStartTime: itemDetails.tourStartTime,
        tourDuration:  itemDetails.tourDuration,
        tourEndTime: itemDetails.tourEndTime,
        mealStartTime: itemDetails.mealStartTime,
        mealEndTime: itemDetails.mealEndTime
      });
    }, [itemDetails.tourDuration, itemDetails.mealDuration, itemDetails.mealStartTime, itemDetails.mealEndTime, confirmDialogue]);

    return (
        <Form onSubmit={handleSubmit}>

        <FormItem
              label="Resource Name"
              style={{ display: "flex", marginBottom: 5 }}
        >
              <Input
                name="resourceName"
                value={resource.name}
                disabled
                size={'large'}
                placeholder={''}/>
        </FormItem>
          <FormItem
              label="Day Type"
              style={{ display: "flex", marginBottom: 5 }}
          >
            <Select
              name="daytype"
              defaultValue={`dayTypeId-${dayTypes.find((elem) => {
                return elem.id === 25;
              }).id}`}
              onChange={props.handleOmnibusFieldChange}
              style={{ width: 250 }}
            >
              {dayTypes.map((dayType) => {
                return <Option key={dayType.id} value={`dayTypeId-${dayType.id}`}>{dayType.name}</Option>
              })}
            </Select>
          </FormItem>
          <FormItem
          label="Time Zone"
          style={{ display: "flex", marginBottom: 5 }}
          >
            <Select
              name="timeZone"
              value={`timeZoneId-${itemDetails.timeZoneId}`}
              onChange={props.handleOmnibusFieldChange}
              style={{ width: 110 }}
            >
              {timeZones.map((timeZone) => {
                return <Option key={timeZone.id} value={`timeZoneId-${timeZone.id}`}>{timeZone.name}</Option>
              })}
            </Select>
          </FormItem>

            <FormItem
              label="Tour Start Time"
              style={{ display: "flex", marginBottom: 5 }}
            >
              {getFieldDecorator('tourStartTime', {
                    rules: [{
                        required: true, message: 'Please input start time!',
                    }, {
                         validator: validateTourStartTime,
                    }],
                })(
                    <DatePicker
                      name="tourStartTime"
                      showTime={{ format: datePickerFormat, use12Hours: true, minuteStep: 15 }}
                      onChange={props.handleTourStartTimeChange}
                      placeholder={'Select date and time'}
                      format={datePickerFormat}
                      allowClear={false}
                      size={'large'}
                      popupStyle={{ zIndex: 2000 }}
                    />
                )}
            </FormItem>

            <FormItem
              label="Tour Duration"
              style={{ display: "flex", marginBottom: 5 }}
            >
              {  itemDetails.tourDuration && itemDetails.tourDurationDays && itemDetails.tourDurationDays.days &&
                (
                  <span>
                    <Mentions
                      value={itemDetails.tourDurationDays.days}
                      readOnly
                      style={{ marginLeft: 10, marginRight: 5, width: 50 }}
                    />
                    <span>day(s) &</span>
                  </span>
                )
              }
                {getFieldDecorator('tourDuration', {
                rules: [{
                    required: true, message: 'Duration is required!',
                    type: 'object'
                }],
                  })(
                      <TimePicker
                        name="tourDuration"
                        onChange={props.handleTourDurationChange}
                        allowClear={false}
                        format={durationFormat}
                        minuteStep={15}
                        style={{ marginLeft: 5, marginRight: 5 }}
                      />
                )}
              hours
            </FormItem>

            <FormItem
              label="Tour End Time"
              style={{ display: "flex", marginBottom: 5 }}
            >
              {getFieldDecorator('tourEndTime', {
                    rules: [{
                        required: true, message: 'Please input end time!',
                    }, {
                         validator: validateTourEndTime,
                    }],
                })(
                    <DatePicker
                      name="tourEndTime"
                      showTime={{ format: datePickerFormat, use12Hours: true, minuteStep: 15 }}
                      onChange={props.handleTourEndTimeChange}
                      placeholder={'Select date and time'}
                      format={datePickerFormat}
                      size={'large'}
                      popupStyle={{ zIndex: 2000 }}
                    />
                )}
            </FormItem>

            <FormItem
              label="Meal Start Time"
              style={{ display: "flex", marginBottom: 5 }}
            >
              {getFieldDecorator('mealStartTime', {
                    rules: [{
                        validator: validateMealStartTime,
                    }],
                })(
                    <DatePicker
                      name={'mealStartTime'}
                      showTime={{ format: datePickerFormat, use12Hours: true, minuteStep: 15 }}
                      onChange={props.handleMealStartTimeChange}
                      format={datePickerFormat}
                      allowClear
                      placeholder={'Select time'}
                      size={'large'}
                      popupStyle={{ zIndex: 2000 }}
                    />
              )}
            </FormItem>

            <FormItem
              label="Meal End Time"
              style={{ display: "flex", marginBottom: 5 }}
            >
              {getFieldDecorator('mealEndTime', {
                    rules: [{
                        validator: validateMealEndTime,
                    }],
                })(
                  <DatePicker
                    name={'mealEndTime'}
                    showTime={{ format: datePickerFormat, use12Hours: true, minuteStep: 15 }}
                    onChange={props.handleMealEndTimeChange}
                    format={datePickerFormat}
                    placeholder={'Select time'}
                    size={'large'}
                    popupStyle={{ zIndex: 2000 }}
                  />
              )}
            </FormItem>

            <FormItem
                  label="Tour Comment"
                  style={{ display: "flex", marginBottom: 5 }}
            >
              {getFieldDecorator('tourComment', {
                  rules: [{
                      validator: validateCommentField,
                  }],
              })(
                <TextArea
                  name="tourComment"
                  onChange={props.handleOmnibusFieldChange}
                  size={'large'}
                  placeholder={'Enter text here.'}/>
              )}
            </FormItem>

            <FormItem
              label="Notification Comment"
              style={{ display: "flex", marginBottom: 5 }}
            >
              {getFieldDecorator('notificationComment', {
                  rules: [{
                      validator: validateCommentField,
                  }],
              })(
                <TextArea
                  name="notificationComment"
                  onChange={props.handleOmnibusFieldChange}
                  size={'large'}
                  placeholder={'Enter text here.'}/>
              )}
            </FormItem>

            <FormItem
              label="Show as busy on tour hours: "
              style={{ display: "flex", marginBottom: 5 }}
            >
              <Checkbox
                name="showBusy"
                onChange={props.handleOmnibusFieldChange}
                size={'large'}
              />
            </FormItem>

            <FormItem
              style={{ marginTop: 20 }}
            >
              <Button type="primary" block size={'large'} htmlType="submit">
                Save
              </Button>
            </FormItem>
        </Form>
    );
}

const WrappedAddTourGeneralForm = Form.create()(AddTourGeneralForm);

export default WrappedAddTourGeneralForm;




// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/Forms/AddTourGeneralForm.js